import Cookies from "universal-cookie";
import AxiosInstance from "./Axios";

const API_BASE = "/admin/user";

function logValidationError(message) {
  console.error(message);
  return null;
}

export async function GetAdminUsers() {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    return await AxiosInstance.get(API_BASE, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

export async function CreateAdminUser(user) {
  if (!user || typeof user !== "object") {
    return logValidationError("Debes enviar un objeto 'user'.");
  }

  const email = String(user.email ?? "").trim();
  const password = String(user.password ?? "").trim();
  const username = String(user.username ?? "").trim();
  const enable = Boolean(user.enable);
  const isSuper = Boolean(user.super);

  const required = { email, password, username };
  const missing = Object.entries(required)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missing.length) {
    return logValidationError(`Faltan campos obligatorios: ${missing.join(", ")}`);
  }

  const body = {
    email,
    password,
    username,
    enable,
    super: isSuper,
  };

  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    return await AxiosInstance.post(API_BASE, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

export async function UpdateAdminUser(user) {
  if (!user || typeof user !== "object") {
    return logValidationError("Debes enviar un objeto 'user'.");
  }

  const id = user.id ?? user._id;
  const email = String(user.email ?? "").trim();
  const username = String(user.username ?? "").trim();
  const password = String(user.password ?? "").trim();
  const enable = Boolean(user.enable);
  const isSuper = Boolean(user.super);

  const required = { id, email, username };
  const missing = Object.entries(required)
    .filter(([, value]) => !String(value ?? "").trim())
    .map(([key]) => key);

  if (missing.length) {
    return logValidationError(`Faltan campos obligatorios: ${missing.join(", ")}`);
  }

  const body = {
    id,
    email,
    username,
    enable,
    super: isSuper,
    ...(password ? { password } : {}),
  };

  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    return await AxiosInstance.put(API_BASE, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

export async function DeleteAdminUser(id) {
  if (!String(id ?? "").trim()) {
    return logValidationError("Falta el campo obligatorio: id");
  }

  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    return await AxiosInstance.delete(API_BASE, {
      params: { id },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

export default {
  getAdminUsers: GetAdminUsers,
  createAdminUser: CreateAdminUser,
  updateAdminUser: UpdateAdminUser,
  deleteAdminUser: DeleteAdminUser,
};
